
// Verifica primeiro no window.env, depois no process.env
function getEnvValue(key: string, defaultValue: string = ''): string {
  // Verificar primeiro no window.env (maior prioridade)
  if (window.env && window.env[key] !== undefined) {
    return window.env[key];
  }
  
  // Verificar no process.env
  const envKey = key.startsWith('REACT_APP_') ? key : `REACT_APP_${key}`;
  if (process.env[envKey] !== undefined) {
    return process.env[envKey] as string;
  }
  
  // Fallback para valor padrão
  return defaultValue;
}

// Determinar ambiente
const isDevelopment = process.env.NODE_ENV === 'development';

// URLs diferentes para desenvolvimento e produção
export const API_URL = isDevelopment
  // Reserva de DESENVOLVIMENTO: homologação, nunca produção. Apontava para
  // app.n0.pt — o host real —, então quem rodasse sem .env gravava em dados
  // de cliente sem perceber.
  ? process.env.REACT_APP_API_URL || 'https://app-homol.horsetech.com.br/api'
  // Em produção a API vive na PRÓPRIA origem do admin (nginx faz o proxy em
  // adm.horsetech.com.br e homol.horsetech.com.br). Host fixo aqui seria
  // regressão: foi o que amarrou o build a app.n0.pt:4211.
  : process.env.REACT_APP_API_URL || '/api';

// Log no início para depuração
console.log("API URL:", API_URL, "Ambiente:", process.env.NODE_ENV);

// Interface para o usuário
export interface UserData {
  userId: number;
  Nome: string;
  Role: string;
}

// Função para normalizar caminhos URL
export function normalizarUrl(url: string): string {
  // Remover barras iniciais
  while (url.startsWith('/')) {
    url = url.substring(1);
  }
  // Remover barras duplas no meio da string, mas preservar https://
  return url.replace(/([^:])\/+/g, '$1/');
}

// Função para obter o token de autenticação
export const getAuthToken = (): string | null => {
  return localStorage.getItem("token");
};

// Função para obter os dados do usuário
export const getUserData = (): UserData | null => {
  const userStr = localStorage.getItem("user");
  if (!userStr) return null;
  try {
    return JSON.parse(userStr) as UserData;
  } catch (error) {
    console.error("Erro ao processar dados do usuário:", error);
    return null;
  }
};

// Função para verificar se um endpoint precisa do userId.
//
// ATENÇÃO: esta é uma SEGUNDA cópia da lista que vive no interceptor de
// services/api.ts, e nada a chama hoje. Mantida em sincronia para que, se
// alguém voltar a usá-la, não divirja em silêncio — o certo seria apagar uma
// das duas.
export const needsUserId = (url: string): boolean => {
  return url.includes("tenant") ||
    url.includes("partner") ||
    url.includes("role") ||
    url.includes("stable") ||
    url.includes("stall") ||
    url.includes("horse") ||
    url.includes("recorder") ||
    url.includes("camera") ||
    (url.includes("user") && !url.endsWith("user"));
};